module.exports = __webpack_public_path__ + "assets/img/G-L7-B1.a36aac4d.png";